import React from "react";
import MaskedInput from "react-text-mask";
import InputDefault from "./InputDefault";
import { customCurrencyMask } from '../../utils/CurrencyMask';

export const CurrencyMask = props => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      placeholderChar={"\u2000"}
      showMask={props.showmask}
      mask={customCurrencyMask()}
      {...other}
    />
  );
};

export const InputCurrency = props => {
  return (
    <InputDefault InputProps={{ inputComponent: CurrencyMask }} {...props} />
  );
};
